import React from 'react';
import ApplicationsPermissionsTableView from '../../views/applications/permissions';
import UUID from 'uuid';
import CurrentApplicationLabel from './current-label';

class ApplicationPermissionsTableScreen extends React.Component {

  state = {
    name: ''
  };

  onSave = async (data, setData) => {
    const input = {
      ...data,
      uuid: data.uuid || UUID.v4()
    };
    await setData({
      ...input
    });
  };

  onDelete = async (data, remove) => {
    if (!data.uuid) {
      return remove(data.uuid);
    }
    await remove(data.uuid);
  };

  getPermissions() {
    return [
      {
        key: 'Change other user password',
        defaultValue: false,
        cascading: true
      },
      {
        key: 'View users',
        defaultValue: false,
        cascading: true
      },
      {
        key: 'Edit users',
        defaultValue: false,
        cascading: true
      },
      {
        key: 'View customers',
        defaultValue: false,
        cascading: true
      },
      {
        key: 'Edit account',
        defaultValue: true,
        cascading: true
      },
      {
        key: 'Change password',
        defaultValue: true,
        cascading: false
      }
    ]
  }

  render() {
    return (
      <ApplicationsPermissionsTableView
        name={(
          <React.Fragment>
            <CurrentApplicationLabel />&nbsp;Permissions
          </React.Fragment>
        )}
        permissions={this.getPermissions()}
        onSave={this.onSave}
        onDelete={this.onDelete}
      />
    )
  }
}

export default ApplicationPermissionsTableScreen;



// WEBPACK FOOTER //
// ./src/app/applications/permissions.js